// Configuración centralizada de iconos para estados de propiedades

import { Building2, DoorClosed, DoorOpen, Clock, EyeOff } from 'lucide-react';

/**
 * Configuración centralizada de iconos para estados de propiedades
 * Usado en StatsCards y PropertyCard para mantener consistencia visual
 */
export const PROPERTY_ICONS = {
  TOTAL: {
    icon: Building2,
    color: 'text-amber-400',
    bgColor: 'bg-amber-400/10',
    label: 'Propiedades'
  },
  UPCOMING: {
    icon: DoorClosed,
    color: 'text-blue-400',
    bgColor: 'bg-blue-400/10',
    label: 'Próximas'
  },
  BLIND_WAITING: {
    icon: DoorOpen,
    color: 'text-purple-400',
    bgColor: 'bg-purple-400/10',
    label: 'Oferta Ciega (Esperando)'
  },
  BLIND_ACTIVE: {
    icon: DoorOpen,
    color: 'text-purple-400',
    bgColor: 'bg-purple-400/10',
    label: 'Oferta Ciega (Activa)'
  },
  OPEN: {
    icon: DoorOpen,
    color: 'text-green-400',
    bgColor: 'bg-green-400/10',
    label: 'Subasta Abierta'
  },
  LAST_CHANCE: {
    icon: Clock,
    color: 'text-amber-400',
    bgColor: 'bg-amber-400/10',
    label: 'Última Oportunidad'
  },
  CLOSED: {
    icon: DoorClosed,
    color: 'text-red-400',
    bgColor: 'bg-red-400/10',
    label: 'Finalizadas'
  }
};

/**
 * Obtener configuración de icono según el estado
 * @param {string} status - Estado de la propiedad ('UPCOMING', 'OPEN', 'LAST_CHANCE', 'CLOSED')
 * @returns {object} Configuración del icono
 */
export const getPropertyIcon = (status) => {
  return PROPERTY_ICONS[status] || PROPERTY_ICONS.CLOSED;
};